<template>
  <div class="px-4">
    <p class="mb-2 text-xs uppercase tracking-wider text-gray-600">
      {{ $t('components.reservation.edit.forms.title') }}
    </p>
    <p v-if="!hasRequestedForms" class="py-2 text-gray-600 text-sm mb-6">
      {{ $t('components.reservation.edit.forms.noForms') }}
    </p>
    <div v-else class="rounded-xl border mb-6 p-2 divide-y bg-white dark:bg-gray-800/50 dark:border-gray-800 text-sm">
      <requested-form
        v-for="form in requestedForms"
        :key="form.idCustomerForm"
        :form="form"
        :reservation="reservation"
        type="requested"
      />
    </div>

    <div v-if="hasRelatedForms">
      <p class="mb-2 text-xs uppercase tracking-wider text-gray-600">
        {{ $t('components.reservation.edit.forms.related') }}
      </p>
      <div class="rounded-xl border mb-6 p-2 divide-y bg-white dark:bg-gray-800/50 dark:border-gray-800 text-sm">
        <related-form
          v-for="form in relatedForms"
          :key="form.idServiceForm"
          :form="form"
          :reservation="reservation"
          type="related"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RequestedForm from './RequestedForm.vue'
import RelatedForm from './RelatedForm.vue'

import {
  ODropdown,
} from '@/components/elements'

interface Props {
  reservation: Record<string, any>
}

const props = defineProps<Props>()

const requestedForms = computed(() => props.reservation.forms)
const hasRequestedForms = computed(() => requestedForms.value?.length)
const relatedForms = computed(() => props.reservation.relatedForms)
const hasRelatedForms = computed(() => relatedForms.value?.length)
</script>
